// This file defines the main navigation configuration 
// The config is used in the common ui angular library as input for rendering the TaaS standard main navigation on the left side

import { TaasMenuItem } from "utimaco-common-ui-angular";

// see https://netbasal.com/simplifying-file-imports-in-angular-with-new-loader-options-4e94a0eb18af for importing svgs in angular ^17.1
import homeIcon from '@material-icons/svg/svg/home/baseline.svg';

export const TAAS_MENU_ITEM_LIST_TS: TaasMenuItem[] = [
    { id: 0, type: "link", active: true, name: $localize`:main-menu home link:Home`, link: "/", iconSvg: homeIcon, children: [] },
    /* usage example for sections with child elements
    {
        id: 1, type: "section", active: false, name: $localize`:main-menu reports link:Reports`, link: "/reports", iconSvg: chartIcon, children: [
            { id: 4, type: "link", active: false, name: $localize`:main-menu transactions link:Transactions`, link: "/reports/transactions", iconSvg: transactionsIcon, children: [] },
        ]
    },
    */
];